import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ReportTimePeriod } from '@mona/models';
import { ReportTimePeriodState } from '../../entities/time-period.state';
import * as ReportsActions from '../actions/reports.actions';

/**  EntityAdapter<TimePeriod> */
export const reportTimePeriodsAdapter: EntityAdapter<ReportTimePeriod> = createEntityAdapter<ReportTimePeriod>({
    selectId: (timePeriod: ReportTimePeriod) => timePeriod.name,
});

const initialState: ReportTimePeriodState = reportTimePeriodsAdapter.getInitialState({
    error: null,
    isLoading: false,
});

export const timePeriodsReducer = createReducer(
    initialState,
    on(ReportsActions.loadReportsTimePeriods, state => ({ ...state, error: null, isLoading: true })),
    on(ReportsActions.loadReportsTimePeriodsFailure, (state, { error }) => ({ ...state, error, isLoading: false })),
    on(ReportsActions.loadReportsTimePeriodsSuccess, (state, action) => ({
        ...reportTimePeriodsAdapter.setAll(action.timePeriods, state),
        error: null,
        isLoading: false,
    })),
    on(ReportsActions.clearTimePeriods, state => reportTimePeriodsAdapter.removeAll(state)),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = reportTimePeriodsAdapter.getSelectors();
